import React from 'react';
import { aboutEterrnal } from '../data/mock';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 lg:py-32 bg-[#F8F7F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Image */}
          <div className="relative">
            <img
              src={aboutEterrnal.image}
              alt="Healing crystals"
              className="w-full h-[400px] lg:h-[500px] object-cover"
            />
            <div className="absolute -top-4 -left-4 w-32 h-32 border border-[#B8A88A]/30" />
          </div>

          {/* Content */}
          <div>
            <p className="text-sm tracking-[0.2em] text-[#6B8F71] mb-4 uppercase">
              {aboutEterrnal.subtitle}
            </p>
            
            <h2 className="text-3xl lg:text-4xl font-light text-[#333333] mb-8">
              {aboutEterrnal.title}
            </h2>
            
            <div className="space-y-6">
              {aboutEterrnal.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-base text-[#666666] leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
